import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Base.css';
const VerifyCheckVerificationFail = () => {
    const selectVerifyCheckState = (state) => state.verifyCheck;
    const verifyCheckState = useSelector(selectVerifyCheckState);
    const dispatch = useDispatch();
    const processStateAction = (x) => ({ type: 'GOTO_PROCESS_STATE', processState: x });
    const submitData = (e) => {
        dispatch(processStateAction(e.currentTarget.value));
    };
    return React.createElement("div", null,
        React.createElement("div", null, "Verification Failed"),
        React.createElement("div", null, "The verification code provided does not match the check number or the check number you provided does not exist."),
        React.createElement("div", null, "If you believe this to be in error, please contact Support."),
        React.createElement("div", { className: "button_container" },
            React.createElement("button", { className: "btn btn-primary", name: "btnTryAgain", value: "start", onClick: submitData }, "Try Again")));
};
export default VerifyCheckVerificationFail;
//# sourceMappingURL=VerifyCheckVerificationFail.js.map